import Modal from "@/components/common/modal";
import {
  Avatar,
  AvatarFallback,
  Button,
  Icon,
} from "@elaniintc/goes-design-system";

export interface EntityRegistryErrors {
  [fieldKey: string]: string[];
}

interface ErrorSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors: EntityRegistryErrors;
}

const regex = /'([^']*)'/;

const ErrorSummaryModal = ({
  isOpen,
  onClose,
  errors,
}: ErrorSummaryModalProps) => {
  if (!isOpen) return null;

  const errorEntries = Object.entries(errors ?? {});

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Resumen de errores"
      description="Verifica los campos marcados con error y corralos antes de guardar el registro."
      modalContentClassName="w-full max-w-[var(--size-horizontal-sm)]"
    >
      <div className="space-y-4">
        <div
          className="w-full max-h-[60vh] overflow-y-auto space-y-3 py-4 pr-1"
          data-testid="entity-registry-error-summary-nodes-list"
        >
          {errorEntries.map(([fieldKey, fieldErrors]) => {
            const displayErrors =
              (fieldErrors || []).length > 0
                ? fieldErrors.map((message) => ({ message }))
                : [
                    {
                      message: "Error en la configuración del registro.",
                    },
                  ];

            return (
              <div
                key={`error-node-${fieldKey}`}
                className="flex flex-col gap-2 rounded-lg border border-neutral-quiet bg-neutral-object p-3"
              >
                <div className="flex min-w-0 max-w-fit gap-2 items-center rounded-lg bg-surface-danger-accent-quiet px-2 py-1">
                  <Avatar shape="circle" size="2xs">
                    <AvatarFallback shape="circle" type="icon" color="danger">
                      <Icon type="fas" name="exclamation-triangle" />
                    </AvatarFallback>
                  </Avatar>
                  <p
                    className="text-danger leading-3xl font-semibold"
                    style={{ wordBreak: "break-all", whiteSpace: "normal" }}
                  >
                    {(() => {
                      const match = regex.exec(displayErrors?.[0]?.message);
                      return match ? match[1] : displayErrors?.[0]?.message;
                    })()}
                  </p>
                </div>
                <ul className="flex flex-col gap-2 pt-1 px-1">
                  {displayErrors.map((error, errIdx) => (
                    <li
                      key={`node-error-${fieldKey}-${errIdx}`}
                      className="text-danger"
                    >
                      <p
                        className="text-danger leading-snug font-normal text-sm"
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {error.message.split("'").pop()?.trim()}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <Button variant="tertiary" className="w-full" onClick={onClose}>
          Aceptar
        </Button>
      </div>
    </Modal>
  );
};

export default ErrorSummaryModal;
